<template>
  <b-card
    no-body
    class="d-flex justify-content-between align-items-right hero"
  >
    <b-row>
      <b-col
        cols="8"
        class="text-sm-left mb-0"
      >
        <span
          class="mb-0 font-weight-bolder mian"
          style="font-size:20px;"
        >Fire Alarm
        </span>
      </b-col>
      <b-col
        cols="4"
        class="text-sm-right mt-0"
      >
        <b-button
          id="toggle-btn"
          v-b-modal="'modalFireAlarm'"
          variant="primary"
          style="font-size: 14px;"
          title="Click to show more"
        >
          View<feather-icon
            size="14"
            icon="ChevronsRightIcon"
          />
        </b-button>
      </b-col>
    </b-row>
    <ModalFireAlarm
      @fetch="dataElevator()"
    />
    <app-echart-alarm
      :option-data="option"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCol, BButton, BRow,
  // BCardBody,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartAlarm from '@core/components/charts/echart/AppEchartAlarm.vue'
import ModalFireAlarm from '@/views/StatisModal/ModalFireAlarm.vue'

export default {
  components: {
    BCard,
    BCol,
    BButton,
    AppEchartAlarm,
    ModalFireAlarm,
    BRow,
    // BCardBody,
    // BAvatar,
    // BImg,
  },
  data() {
    return {
      Total: '',
      Normal: '',
      Alarm: '',
      items: [],
      option: {
        xAxis: [
          {
            type: 'category',
            data: ['Normal', 'Alarm'],
            axisLabel: {
              hideOverlap: true,
              show: true,
              fontSize: 12,
              color: '#fff',
            },
          },
        ],
        yAxis: [
          {
            axisLabel: {
              hideOverlap: true,
              show: true,
              fontSize: 12,
              color: '#fff',
            },
            type: 'value',
            splitLine: { show: false },
          },
        ],
        grid: {
          show: false,
          containLabel: false,
          borderWidth: '1px',
          left: '40px',
          right: '30px',
          bottom: '25px',
          top: '25px',
        },
        series: [
          {
            data: [
              {
                name: 'Normal',
                value: '',
                itemStyle: {
                  color: '#04FF15',
                  barBorderRadius: [5, 5, 0, 0],
                },
                label: {
                  show: true,
                  position: 'top',
                  fontWeight: 'bold',
                  fontSize: 16,
                  color: '#fff',
                },
              },
              {
                name: 'Alarm',
                value: '',
                itemStyle: {
                  color: '#FA0404',
                  barBorderRadius: [5, 5, 0, 0],
                },
                label: {
                  show: true,
                  position: 'top',
                  fontWeight: 'bold',
                  fontSize: 16,
                  color: '#fff',
                },
              },
            ],
            barWidth: '40%',
            type: 'bar',
          },
        ],
      },

    }
  },
  created() {
    setInterval(() => {
      this.getChat()
    }, 7000)
  },
  mounted() {
    this.getChat()
  },
  methods: {
    getChat() {
      axios
        .get('/get_fireAlarm')
        .then(response => {
          this.xAxis = []
          this.xAxis = response.data
          this.xAxis.forEach(value => {
            this.option.xAxis.push(value.Total)
            this.option.series[0].data[0].value = value.Normal
            this.option.series[0].data[1].value = value.Alarm
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
<style scoped>

.hero::before {
      content: "";
      background-image: url(~@/assets/images/icons/fa.jpg);
      position: absolute;
      background-size: cover;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      opacity: 0.4;
      border-radius: 20px;
  }

.mian {
  position: relative;
  color: #ffffff;
  font-size: 14rem;
  line-height: 1.8;
  text-align: center;
  padding: 5px;text-align: left; font-size:14px; text-decoration: underline
}
.p {
  position: relative;
  color: #ffffff;
  font-size: 14rem;
  line-height: 0.9;
  padding: 5px;text-align: left; font-size:14px;
}
</style>
